export const Role = ["運送業者", "現場監督", "見学者", "警備員", "作業員", "配車会社", "ロボット", "ドローン"]
export const Status = ["","完了", "搬入待ち", "確認待ち", "NG", "分納中"]
